import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.979 4.26a1.224 1.224 0 0 1 0 2.449c-.672 0-1.22-.549-1.22-1.222a1.223 1.223 0 0 1 1.22-1.227Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-.021-8.031a2.487 2.487 0 0 0 2.484-2.482A2.488 2.488 0 0 0 7.979 3a2.488 2.488 0 0 0-2.485 2.487A2.487 2.487 0 0 0 7.979 7.97Zm-3.377.164c-.284.527.039.78.776 1.21.626.365 1.49.499 2.046.552l-2.19 1.988c-.637.577.39 1.501 1.026.937l1.724-1.57.032.03c.649.589 1.268 1.151 1.692 1.542.638.567 1.663-.35 1.033-.937l-.97-.877-.001-.001-1.226-1.11c.563-.053 1.414-.195 2.033-.552.737-.433 1.06-.685.78-1.212-.17-.3-.626-.55-1.234-.117 0 0-.82.593-2.144.593-1.324 0-2.144-.593-2.144-.593-.607-.435-1.065-.182-1.232.117Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconOKFilled16 = createIcon(IconComponent);